import React, { useState } from "react";
import Sidenavbar from "../../Sidenavbar";
import Topbar from "../../Topbar";
import "../../../styles/CommonStyle.scss";
import "../../../styles/Tasks.scss";
import { Link } from "react-router-dom";
import { Button, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import { optionsPageSizeList } from "../../DropdownsData";
import projectImage from "../../../images/products/task-img.png";
import projectImage1 from "../../../images/products/project-plan-1.png";
import completedIcon from "../../../images/completed-icon.jpg";
import pendingIcon from "../../../images/pending-icon.png";
import projectPersonImg from "../../../images/profile-1.png";
import editIcon from "../../../images/icons/pen-to-square-solid.svg";
import AddTask from "./AddTask";
import EditTask from "./EditTask";

export default function Tasks() {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [show, setShow] = useState(false);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [viewProductDetail, setViewProductDetail] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const toggleMenu = () => {
    if (menuCollapse === true) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalemployee, setTotalemployee] = useState(0);
  const [pageDataSize, setPageDataSize] = useState(0);
  const [itemOffset, setItemOffset] = useState(1);
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const pageDataFrom = currentPage * PageSize - PageSize + 1;
  const pageDataTill = pageDataFrom + pageDataSize - 1;
  // console.log("From:", pageDataFrom, "TO", pageDataTill);
  // PAGINATION END

  const handleClose = () => {
    setShow(false);
    setEditTask(false);
    setViewProductDetail(false);
  };

  return (
    <div id="main-page">
      {/* SIDEBAR START */}
      <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
      {/* SIDEBAR END */}

      {/* TOPBAR START */}
      <Topbar
        toggleMenu={toggleMenu}
        menuCollapse={menuCollapse}
        toggleshift={toggleshift}
      />
      {/* TOPBAR END */}

      {/* MAIN BODY START */}
      <div className="page-wrapper">
        {/* PAGE CONTENT START */}
        <div className={`main-body ${toggleshift.style}`}>
          <div className="page-content">
            {/* USER TABLE START */}
            <div className="task-table">
              <div className="seleting-menus">
                <div className="page-title">TASKS</div>

                <div className="page-top-bar-dropdowns">
                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Select"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Select"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Select"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <div className="input-group from-to-date-select">
                    <span className="input-group-text" id="from-label">
                      From
                    </span>
                    <span className="date-picker-with-icon">
                      <DatePicker
                        selected={fromDate}
                        className="select from-date"
                        id="from-datepicker"
                        dateFormat="dd/MM/yyyy"
                        selectsEnd
                        // startDate={fromDate}
                        endDate={toDate}
                        onChange={(date) => setFromDate(date)}
                        maxDate={toDate}
                      />
                      <i className="fa fa-calendar-o calander-icon" />
                    </span>

                    <span className="input-group-text" id="to-label">
                      To
                    </span>
                    <span className="date-picker-with-icon">
                      <DatePicker
                        selected={toDate}
                        className="select to-date"
                        id="from-datepicker"
                        dateFormat="dd/MM/yyyy"
                        selectsEnd
                        // startDate={fromDate}
                        endDate={toDate}
                        minDate={fromDate}
                        onChange={(date) => setToDate(date)}
                        // maxDate={new Date()}
                      />
                      <i className="fa fa-calendar-o calander-icon" />
                    </span>
                  </div>

                  <button
                    type="button"
                    className="btn btn-search-track"
                    // onClick={clearSerachBySelect}
                  >
                    <span className="btn-inline-item d-flex">
                      <i className="fa fa-eraser"> </i>
                      <h6>Clear</h6>
                    </span>
                  </button>

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // defaultValue={optionsRoleList[0].label}
                    options={optionsPageSizeList}
                    placeholder="Show Per Page"
                    value={optionsPageSizeList.value}
                    onInputChange={optionsPageSizeList.label}
                    onChange={(data) => setPageSize(data.value)}
                    isSearchable={true}
                  />

                  <button
                    type="button"
                    className="btn btn-add-project"
                    onClick={() => setShow(!show)}
                  >
                    <span className="btn-inline-item d-flex">
                      <i className="fa fa-plus-square" /> &nbsp;
                      <h6>Add New</h6>
                    </span>
                  </button>
                </div>
              </div>
              <div className="table-responsive task-scrollbar">
                <div className="task-details">
                  <div className="row">
                    <div className="col-md-6 col-sm-12 pl-0">
                      <div className="task-left-part">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-6 p-0">
                              <div className="d-flex">
                                <div className="task-img-status">
                                  <Image
                                    src={projectImage}
                                    className="task-img completed"
                                    alt="image"
                                  />
                                  <div className="task-status completed">
                                    Completed
                                  </div>{" "}
                                </div>
                                <div className="task-details">
                                  <span className="fz14 gryclr">
                                    <strong>023254567</strong>
                                  </span>
                                  <div className="p fz13 gryclr">
                                    Task Name : Phase 01
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Project Name : Planning
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Phase Name : Project 01
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Task Cost : 50,000
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Created On : 16/12/2022
                                  </div>
                                </div>
                              </div>
                              <div className="client-code">
                                <Link to="#" className="client-code-link">
                                  Clint Code :
                                </Link>
                                &nbsp; 82345675234
                              </div>
                            </div>

                            <div className="col-sm-6 p-0">
                              <div className="task-person-deatils">
                                <div className="task-person-status d-flex">
                                  <div className="task-person-image">
                                    <Image
                                      src={projectPersonImg}
                                      className="task-person-img"
                                      alt="image"
                                    />
                                  </div>
                                  <div className="task-details">
                                    <span className="fz14 gryclr">
                                      <strong>Raghav J</strong>
                                    </span>
                                    <div className="p fz13 gryclr">
                                      Start Date : 03-01-2023
                                    </div>
                                    <div className="p fz13 gryclr">
                                      End Date : 04-02-2023
                                    </div>
                                    <div className="p fz13 gryclr">
                                      Duration : 1 Month
                                    </div>
                                    <div className="p fz13 gryclr">
                                      Team Members : &nbsp;
                                      <Link to="#" className="team-count">
                                        5
                                      </Link>
                                    </div>
                                  </div>
                                  <Image
                                    src={editIcon}
                                    className="edit-icon"
                                    alt="edit-icon"
                                    onClick={() => setEditTask(!editTask)}
                                  />
                                  <Image
                                    src={completedIcon}
                                    className="status-icon"
                                    alt="status-icon"
                                  />
                                </div>
                                <div className="tasks-download">
                                  <Link to="#" className="task-phase">
                                    <i className="fa fa-life-ring" />
                                    Phases : 5 &nbsp;
                                    <i className="fa fa-plus-circle" />
                                  </Link>
                                  <Link to="#" className="task-task">
                                    <i className="fa fa-file-text-o" />
                                    Tasks : 50 &nbsp;
                                    <i className="fa fa-plus-circle" />
                                  </Link>
                                  <Link to="#" className="task-download">
                                    <i className="fa fa-download" />
                                    Download
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 pr-0">
                      <div className="task-right-part">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-6 p-0">
                              <div className="d-flex">
                                <div className="task-img-status">
                                  <Image
                                    src={projectImage1}
                                    className="task-img pending"
                                    alt="image"
                                  />
                                  <div className="task-status pending">
                                    Pending
                                  </div>{" "}
                                </div>
                                <div className="task-details">
                                  <span className="fz14 gryclr">
                                    <strong>023254567</strong>
                                  </span>
                                  <div className="p fz13 gryclr">
                                    Task Name : Phase 01
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Project Name : Planning
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Phase Name : Project 01
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Task Cost : 50,000
                                  </div>
                                  <div className="p fz13 gryclr">
                                    Created On : 16/12/2022
                                  </div>
                                </div>
                              </div>
                              <div className="client-code">
                                <Link to="#" className="client-code-link">
                                  Clint Code :
                                </Link>
                                &nbsp; 82345675234
                              </div>
                            </div>

                            <div className="col-sm-6 p-0">
                              <div className="task-person-deatils">
                                <div className="task-person-status d-flex">
                                  <div className="task-person-image">
                                    <Image
                                      src={projectPersonImg}
                                      className="task-person-img"
                                      alt="image"
                                    />
                                  </div>
                                  <div className="task-details">
                                    <span className="fz14 gryclr">
                                      <strong>Raghav J</strong>
                                    </span>
                                    <div className="p fz13 gryclr">
                                      Start Date : 03-01-2023
                                    </div>
                                    <div className="p fz13 gryclr">
                                      End Date : 04-02-2023
                                    </div>
                                    <div className="p fz13 gryclr">
                                      Duration : 1 Month
                                    </div>
                                    <div className="p fz13 gryclr">
                                      Team Members : &nbsp;
                                      <Link to="#" className="team-count">
                                        5
                                      </Link>
                                    </div>
                                  </div>
                                  <Image
                                    src={editIcon}
                                    className="edit-icon"
                                    alt="edit-icon"
                                    onClick={() => setEditTask(!editTask)}
                                  />
                                  <Image
                                    src={pendingIcon}
                                    className="status-icon"
                                    alt="status-icon"
                                  />
                                </div>
                                <div className="tasks-download">
                                  <Link to="#" className="task-phase">
                                    <i className="fa fa-life-ring" />
                                    Phases : 5 &nbsp;
                                    <i className="fa fa-plus-circle" />
                                  </Link>
                                  <Link to="#" className="task-task">
                                    <i className="fa fa-file-text-o" />
                                    Tasks : 50 &nbsp;
                                    <i className="fa fa-plus-circle" />
                                  </Link>
                                  <Link to="#" className="task-download">
                                    <i className="fa fa-download" />
                                    Download
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* USER TABLE END */}

            <div className="download-and-pagination">
              <button
                type="button"
                className="btn btn-download-excel"
                // onClick={exportExcelActiivity}
              >
                <i className="fa fa-download" /> &nbsp; Download
              </button>
              <span className="user-pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<i className="fa fa-angle-double-right" />}
                  onPageChange={handlePageClick}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  pageCount={pageCount}
                  previousLabel={<i className="fa fa-angle-double-left" />}
                  renderOnZeroPageCount={null}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  disabledClassName={"disabled"}
                />
              </span>
            </div>

            {/* ADD PRODUCT MODEL START */}
            <AddTask show={show} handleClose={handleClose} />
            {/* ADD PRODUCT MODEL END */}

            {/* EDIT PRODUCT MODEL START */}
            {editTask ? (
              <EditTask editTask={editTask} handleClose={handleClose} />
            ) : (
              ""
            )}
            {/* EDIT PRODUCT MODEL END */}

            {/* PAGE CONTENT END*/}
          </div>
        </div>

        {/* MAIN BODY END */}
      </div>
    </div>
  );
}
